import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServiceResponse } from 'src/app/models/service-response';
import { VisitService } from 'src/app/rest_services/visit.service';
import { Chart, registerables } from 'chart.js';
import { NewactionService } from 'src/app/rest_services/newaction.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { SectorService } from 'src/app/rest_services/sector.service';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";
import * as am4plugins_bullets from "@amcharts/amcharts4/plugins/bullets"; 

import am4geodata_worldMoroccoLow from "@amcharts/amcharts4-geodata/worldMoroccoLow";

import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CityService } from 'src/app/rest_services/city.service';


am4core.useTheme(am4themes_animated);
Chart.register(...registerables);

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  mobile:boolean=false;
  loadingVisitStatistics:boolean = true;
  visitStatistics:Array<any> = [];
  visitStatisticsSubscription!: Subscription;

  loadingActionsStatistics:boolean = true;
  actionsStatistics:Array<any> = [];
  actionsStatisticsSubscription!: Subscription;

  loadingReportedCanceledStatistics:boolean = true;
  loadingClientssStatistics:boolean = true;
  clientsStatistics:Array<any> = [];
  clientsStatisticsSubscription!: Subscription;

  loadingSectorsIndicators:boolean = true;
  sectorsIndicators:Array<any> = [];
  sectorsIndicatorsSubscription!: Subscription;
  
  citiesPresenceCustomersSubscription!: Subscription;
  reportedCanceledStatistics: any[] = [];

  constructor(private visitService: VisitService,
              private actionService: NewactionService,
              private customersService:CustomersService,
              private sectorService : SectorService,
              private cityService : CityService) { }
  currentYear:number=0;
  connectedCompany:any="";
  ngAfterViewInit(){
    this.getCustomersMaps();
  }
  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    if(localStorage.getItem("comp")!=undefined){
      this.connectedCompany = localStorage.getItem("comp")?.toString();
    }else {
      this.connectedCompany = sessionStorage.getItem("comp")?.toString();
    }
    this.getVisitStatistics();
    this.getActionsStatistics();
    this.getAClientssStatistics();
    this.getSectorsIndicators();
    // this.getCustomersMaps();
  }
  getRandomColorHex() {
    var hex = "0123456789ABCDEF",
        color = "#";
    for (var i = 1; i <= 6; i++) {
      color += hex[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getVisitStatistics(){
    this.visitStatisticsSubscription = this.visitService.getVisitsStatistics().subscribe(
      (res: ServiceResponse) => {
        if(res.code == "0f7ab7d2e07faecde64d770cc2b820e9"){
          this.visitStatistics = res.visitsStatistics;
          for (const iterator of this.visitStatistics) {
            iterator.lastName = iterator.firstName+' '+iterator.lastName;
          }
          setTimeout(() => {
            // START - Chart Visits by Commercial Initialisation
            let chart = am4core.create('myChart_visits', am4charts.XYChart)
            chart.colors.step = 2;
            chart.legend = new am4charts.Legend()
            chart.legend.position = 'top'
            chart.legend.paddingBottom = 20
            chart.legend.labels.template.maxWidth = 100
            chart.responsive.enabled = true;
            chart.data = this.visitStatistics;
              // START - Axe x labels properties : Names of commercials
              var xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
              xAxis.dataFields.category = 'lastName'
              xAxis.renderer.cellStartLocation = 0.1
              xAxis.renderer.cellEndLocation = 1
              xAxis.renderer.grid.template.location = 0;
              xAxis.renderer.minGridDistance = 30;
              let label = xAxis.renderer.labels.template;
              label.truncate = false;
              if(this.mobile){
                label.rotation = -45;
                label.horizontalCenter = "right";
                label.verticalCenter = "middle";
                label.fontSize = 8
              }else {
                label.wrap = true;
                label.maxWidth = 120;
                label.fontSize = 12
              }
              // END - Axe x labels properties : Names of commercials
              var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
              yAxis.min = 0;
              // START - Function to create bars of chart
              function createSeries(value:any, name:any) {
                let series = chart.series.push(new am4charts.ColumnSeries())
                series.dataFields.valueY = value
                series.dataFields.categoryX = 'lastName'
                series.name = name
                series.columns.template.tooltipX = am4core.percent(100);
                series.events.on("hidden", arrangeColumns);
                series.events.on("shown", arrangeColumns);
                let bullet = series.bullets.push(new am4charts.LabelBullet())
                bullet.interactionsEnabled = false
                bullet.dy = -15;
                bullet.label.fontSize=  10;
                bullet.label.text = '{valueY}'
                bullet.label.fontWeight = "800";
                bullet.label.truncate = false;
                bullet.label.fill = am4core.color('black')
                return series;
              }
              // END - Function to create bars of chart
              // Definition of legends
              createSeries('created', 'Crées');
              createSeries('planned', 'Planifiées');
              createSeries('done', 'Terminées');
              createSeries('reported', 'Reportées');
              createSeries('canceled', 'Annulées');

              // START - Function properties of bars columns
              function arrangeColumns() {
                var series:any | undefined = chart!.series!.getIndex(0);
                let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
                if (series!.dataItems!.length > 1) {
                  var x0 = xAxis.getX(series.dataItems.getIndex(0),"categoryX");
                  var x1 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                  var delta = ((x1 - x0) / chart.series.length) * w;
                  if (am4core.isNumber(delta)) {
                    let middle = chart.series.length / 2;
                    let newIndex = 0;
                    chart.series.each(function(series:any) {
                      if (!series.isHidden && !series.isHiding) {
                          series.dummyData = newIndex;
                          newIndex++;
                      }
                      else {
                          series.dummyData = chart.series.indexOf(series);
                      }
                    })
                    let visibleCount = newIndex;
                    let newMiddle = visibleCount / 2;
                    chart.series.each(function(series:any) {
                        let trueIndex = chart.series.indexOf(series);
                        let newIndex = series.dummyData;
                        let dx = (newIndex - trueIndex + middle - newMiddle) * delta
                        series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                        series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    })
                  }
                }
              }
              // END - Function properties of bars columns
              // HIDE Logo of Amcharts
              setTimeout(()=>{
                var legends = document.querySelector('g[aria-labelledby="id-1142-title"]');
                legends?.setAttribute("style","display:none !important;")
              }, 300);
            // END - Chart Visits by Commercial Initialisation
          }, 1000);
        }
        this.loadingVisitStatistics = false;
      },
      (err: any) => {
        console.log(err);
        this.loadingVisitStatistics = false;
      }
    );
  }

  getActionsStatistics() {
    this.actionsStatisticsSubscription = this.actionService.getActionsStatistics().subscribe(
        (res: ServiceResponse) => {
            if (res.code == "9ddfb727415b5b5df61b33ceff327870") {
                this.actionsStatistics = res.actionsStatistics;
                for (const iterator of this.actionsStatistics) {
                    iterator.lastName = iterator.firstName + ' ' + iterator.lastName;
                }

                // Initialisation du graphique principal
                this.initMainChart();

                // Initialisation du graphique des actions annulées et reportées
                this.initReportedCanceledChart();
            }
                this.loadingActionsStatistics = false;
                this.loadingReportedCanceledStatistics = false;
        },
        (err: any) => {
            console.log(err);
                this.loadingActionsStatistics = false;
                this.loadingReportedCanceledStatistics = false;
        }
    );
  }

  initMainChart() {
      setTimeout(() => {
          let chart = am4core.create('myChart_actions', am4charts.XYChart)
          chart.colors.step = 2;
          chart.legend = new am4charts.Legend()
          chart.legend.position = 'top'
          chart.legend.paddingBottom = 20
          chart.legend.labels.template.maxWidth = 100
          chart.responsive.enabled = true;
          chart.data = this.actionsStatistics;

          var xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
          xAxis.dataFields.category = 'lastName'
          xAxis.renderer.cellStartLocation = 0.1
          xAxis.renderer.cellEndLocation = 1
          xAxis.renderer.grid.template.location = 0;
          xAxis.renderer.minGridDistance = 30;
          let label = xAxis.renderer.labels.template;
          label.truncate = false;
          if (this.mobile) {
              label.rotation = -45;
              label.horizontalCenter = "right";
              label.verticalCenter = "middle";
              label.fontSize = 8
          } else {
              label.wrap = true;
              label.maxWidth = 120;
              label.fontSize = 12
          }

          var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
          yAxis.min = 0;

          function createSeries(value: any, name: any) {
              let series = chart.series.push(new am4charts.ColumnSeries())
              series.dataFields.valueY = value
              series.dataFields.categoryX = 'lastName'
              series.name = name
              series.columns.template.tooltipX = am4core.percent(100);
              series.events.on("hidden", arrangeColumns);
              series.events.on("shown", arrangeColumns);
              let bullet = series.bullets.push(new am4charts.LabelBullet())
              bullet.interactionsEnabled = false
              bullet.dy = -15;
              bullet.label.fontSize = 10;
              bullet.label.text = '{valueY}'
              bullet.label.fontWeight = "800";
              bullet.label.truncate = false;
              bullet.label.fill = am4core.color('black')
              return series;
          }

          createSeries('done', 'Faites');
          createSeries('inProgress', 'En cours');
          createSeries('notMade', 'Non faites');

          function arrangeColumns() {
              var series: any | undefined = chart!.series!.getIndex(0);
              let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
              if (series!.dataItems!.length > 1) {
                  var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                  var x1 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                  var delta = ((x1 - x0) / chart.series.length) * w;
                  if (am4core.isNumber(delta)) {
                      let middle = chart.series.length / 2;
                      let newIndex = 0;
                      chart.series.each(function (series: any) {
                          if (!series.isHidden && !series.isHiding) {
                              series.dummyData = newIndex;
                              newIndex++;
                          }
                          else {
                              series.dummyData = chart.series.indexOf(series);
                          }
                      })
                      let visibleCount = newIndex;
                      let newMiddle = visibleCount / 2;
                      chart.series.each(function (series: any) {
                          let trueIndex = chart.series.indexOf(series);
                          let newIndex = series.dummyData;
                          let dx = (newIndex - trueIndex + middle - newMiddle) * delta
                          series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                          series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                      })
                  }
              }
          }

          setTimeout(() => {
              var elements = document.querySelectorAll('g[aria-labelledby]');
              Array.prototype.filter.call(elements, function (element) {
                  if (RegExp('-title').test(element.getAttribute("aria-labelledby")) && RegExp('id-').test(element.getAttribute("aria-labelledby"))) {
                      element?.setAttribute("visibility", "hidden")
                  };
              });
          }, 1500);
      }, 1000);
  }
  initReportedCanceledChart() {
    setTimeout(() => {
        let chart = am4core.create('actions_chart', am4charts.XYChart)
        chart.colors.step = 2;
        chart.legend = new am4charts.Legend()
        chart.legend.position = 'top'
        chart.legend.paddingBottom = 20
        chart.legend.labels.template.maxWidth = 100
        chart.responsive.enabled = true;
        chart.data = this.actionsStatistics;

        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
        xAxis.dataFields.category = 'lastName'
        xAxis.renderer.cellStartLocation = 0.1
        xAxis.renderer.cellEndLocation = 1
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 30;
        let label = xAxis.renderer.labels.template;
        label.truncate = false;
        if (this.mobile) {
            label.rotation = -45;
            label.horizontalCenter = "right";
            label.verticalCenter = "middle";
            label.fontSize = 8
        } else {
            label.wrap = true;
            label.maxWidth = 120;
            label.fontSize = 12
        }

        var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;

        function createSeries(value: any, name: any, color: any) {
            let series = chart.series.push(new am4charts.ColumnSeries())
            series.dataFields.valueY = value
            series.dataFields.categoryX = 'lastName'
            series.name = name
            series.columns.template.tooltipX = am4core.percent(100);
            series.columns.template.fill = am4core.color(color);
            series.columns.template.stroke = am4core.color(color);
            series.events.on("hidden", arrangeColumns);
            series.events.on("shown", arrangeColumns);
            let bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = -15;
            bullet.label.fontSize = 10;
            bullet.label.text = '{valueY}'
            bullet.label.fontWeight = "800";
            bullet.label.truncate = false;
            bullet.label.fill = am4core.color('black')
            return series;
        }

        createSeries('doneReported', 'Faites (Reportées)', '#845EC2');
        createSeries('inProgressReported', 'En cours (Reportées)', '#D65DB1');
        createSeries('notMadeReported', 'Non faites (Reportées)', '#FF6F91');
        createSeries('canceled', 'Annulées', '#A91D3A');

        function arrangeColumns() {
            var series: any | undefined = chart!.series!.getIndex(0);
            let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
            if (series!.dataItems!.length > 1) {
                var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                var x1 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                var delta = ((x1 - x0) / chart.series.length) * w;
                if (am4core.isNumber(delta)) {
                    let middle = chart.series.length / 2;
                    let newIndex = 0;
                    chart.series.each(function (series: any) {
                        if (!series.isHidden && !series.isHiding) {
                            series.dummyData = newIndex;
                            newIndex++;
                        }
                        else {
                            series.dummyData = chart.series.indexOf(series);
                        }
                    })
                    let visibleCount = newIndex;
                    let newMiddle = visibleCount / 2;
                    chart.series.each(function (series: any) {
                        let trueIndex = chart.series.indexOf(series);
                        let newIndex = series.dummyData;
                        let dx = (newIndex - trueIndex + middle - newMiddle) * delta
                        series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                        series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    })
                }
            }
        }
    }, 1000);
  }

  getAClientssStatistics(){
    this.clientsStatisticsSubscription = this.customersService.getCompanyCustomersIndicators().subscribe(
      (res: ServiceResponse) => {
        if(res.code == "bb3fd4cd65c20ba03f42375066696314"){
          this.clientsStatistics = res.indicators?.commercialsCustomers;  
             
          setTimeout(()=>{     
            // START - Chart Visits by Commercial Initialisation
            let chart = am4core.create('myChart_customers', am4charts.XYChart)
            chart.colors.step = 2;
            chart.legend = new am4charts.Legend()
            chart.legend.position = 'top'
            chart.legend.paddingBottom = 20
            chart.legend.labels.template.maxWidth = 100
            chart.responsive.enabled = true;
            chart.data = this.clientsStatistics;
            // Modify chart's colors
            chart.colors.list = [
              am4core.color("#845EC2")
            ];
              // START - Axe x labels properties : Names of commercials
              var xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
              xAxis.dataFields.category = 'commercial'
              xAxis.renderer.cellStartLocation = 0.1
              xAxis.renderer.cellEndLocation = 1
              xAxis.renderer.grid.template.location = 0;
              xAxis.renderer.minGridDistance = 30;
              let label = xAxis.renderer.labels.template;
              label.truncate = false;
              if(this.mobile){
                label.rotation = -45;
                label.horizontalCenter = "right";
                label.verticalCenter = "middle";
                label.fontSize = 8
              }else {
                label.wrap = true;
                label.maxWidth = 120;
                label.fontSize = 12
              }
              // END - Axe x labels properties : Names of commercials
              var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
              yAxis.min = 0;
              // START - Function to create bars of chart
              function createSeries(value:any, name:any) {
                let series = chart.series.push(new am4charts.ColumnSeries())
                series.dataFields.valueY = value
                series.dataFields.categoryX = 'commercial'
                series.name = name
                series.columns.template.tooltipX = am4core.percent(100);
                series.events.on("hidden", arrangeColumns);
                series.events.on("shown", arrangeColumns);
                /* Create a heat rule */
                series.heatRules.push({
                  "target": series.columns.template,
                  "property": "fill",
                  "min": am4core.color("#c13f63"),
                  "max": am4core.color("#845ec2"),
                  "dataField": "valueY"
                });
                let bullet = series.bullets.push(new am4charts.LabelBullet())
                bullet.interactionsEnabled = false
                bullet.dy = -15;
                bullet.label.fontSize=  10;
                bullet.label.text = '{valueY}'
                bullet.label.fontWeight = "800";
                bullet.label.truncate = false;
                bullet.label.fill = am4core.color('black')
                return series;
              }
              // END - Function to create bars of chart
              // Definition of legends
              createSeries('customers', 'Clients');
  
              // START - Function properties of bars columns
              function arrangeColumns() {
                var series:any | undefined = chart!.series!.getIndex(0);
                let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
                if (series!.dataItems!.length > 1) {
                  var x0 = xAxis.getX(series.dataItems.getIndex(0),"categoryX");
                  var x1 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                  var delta = ((x1 - x0) / chart.series.length) * w;
                  if (am4core.isNumber(delta)) {
                    let middle = chart.series.length / 2;
                    let newIndex = 0;
                    chart.series.each(function(series:any) {
                      if (!series.isHidden && !series.isHiding) {
                          series.dummyData = newIndex;
                          newIndex++;
                      }
                      else {
                          series.dummyData = chart.series.indexOf(series);
                      }
                    })
                    let visibleCount = newIndex;
                    let newMiddle = visibleCount / 2;
                    chart.series.each(function(series:any) {
                      let trueIndex = chart.series.indexOf(series);
                      let newIndex = series.dummyData;
                      let dx = (newIndex - trueIndex + middle - newMiddle) * delta
                      series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                      series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    })
                  }
                }
              }
          }, 1000);
        }
        this.loadingClientssStatistics = false;
      },
      (err: any) => {
        console.log(err);
        this.loadingClientssStatistics = false;
      }
    );
  }

  ngOnDestroy() {
    this.visitStatisticsSubscription?.unsubscribe();
    this.actionsStatisticsSubscription?.unsubscribe();
    this.clientsStatisticsSubscription?.unsubscribe();
    this.sectorsIndicatorsSubscription?.unsubscribe();
  }

  indicators:any[]=[];
  withoutCustomers:any[]=[];
  noIndicatorsSectorsExist:boolean=false;
  getSectorsIndicators(){
    this.loadingSectorsIndicators = true;
    this.sectorsIndicatorsSubscription = this.sectorService.getSectorsIndicators().subscribe(
      (res: any) => {
        if(res.code == "1125d1fec84b71594c2f9786a8820f28"){
          this.noIndicatorsSectorsExist = false;
          this.indicators = res.sectorIndicator;     
          this.withoutCustomers = res.sectorsWithoutCustomers;     
          const labels = [];
          const values = [];
          for (const iterator of this.indicators) {
            labels.push(iterator.sector);
            values.push(iterator.countCustomers);
          }
          let chart = am4core.create("myChart_sectors", am4charts.PieChart3D);
          chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
          // chart.legend.labels.template.fill = am4core.color("#f00");
          // chart.legend.valueLabels.template.fill = am4core.color("#f00"); 
          chart.legend = new am4charts.Legend();
          chart.responsive.enabled = true;
          if(this.mobile){
            chart.responsive.rules.push({
              relevant: function(target) {
                if (target.pixelWidth <= 800) {
                  return true;
                }
                return false;
              },
              state: function(target:any, stateId:any) :any{
                if (target instanceof am4charts.Chart) {
                  var state = target.states.create(stateId);
                  state.properties.paddingTop = 0;
                  state.properties.paddingRight = 25;
                  state.properties.paddingBottom = 0;
                  state.properties.paddingLeft = 25;
                  return state;
                } else if (target instanceof am4charts.AxisLabelCircular ||
                  target instanceof am4charts.PieTick) {
                  var stat = target.states.create(stateId);
                  stat.properties.disabled = true;
                  return stat;
                }
                return null;
              }
            });
          }
          chart.data = res.sectorIndicator;
          chart.legend.maxHeight = 150;
          chart.legend.maxWidth = 300;
          chart.legend.scrollable = true;
          chart.innerRadius = 80;
          chart.legend.labels.template.text = "{sector}: [bold {color}]({countCustomers})[/]";
          
          
          let series = chart.series.push(new am4charts.PieSeries3D());
          series.labels.template.text = "[bold]--- [/]{category}";
          series.labels.template.fontSize= "13px"; 
          series.labels.template.text = series.labels.template.text + " : [bold]({value})[/]";
          series.dataFields.value = "countCustomers";
          series.dataFields.category = "sector";
          series.labels.template.maxWidth = 280;
          series.labels.template.wrap = true;
          //series.labels.template.paddingTop = 0;
          //series.labels.template.paddingBottom = 0;
          series.labels.template.padding(1, 1, 1, 1);
          setTimeout(()=>{
            var legends = document.querySelector('g[aria-labelledby="id-66-title"]');
            legends?.setAttribute("style","display:none !important;")
          }, 300);
        }else {
          this.noIndicatorsSectorsExist = true;
        }
        this.loadingSectorsIndicators = false;
      },
      (err: any) => {
        console.log(err);
        this.loadingSectorsIndicators = false;
      }
    );
  }
  loadingCustomersMaps:boolean=true;
  getCustomersMaps() {
    this.citiesPresenceCustomersSubscription = this.cityService.getPresentCitiesCustomers().subscribe(
      (res: any) => {
        if(res.code == "13d4895518c85b84c8e6940b6c4772e9"){
          this.loadingCustomersMaps = false;
          var listCities:any[] = [];
          
          for(let city of res.cities){
            city.percentage = city.percentage.toFixed(1);
            city.latitude = Number.parseFloat(city.latitude);
            city.longitude = Number.parseFloat(city.longitude);
            var cit = {
              customers:city.countCustomers,
              city:city.city,
              value:Number(city.percentage)
            }
            listCities.push(cit);
          }
          listCities = listCities.sort((a, b) => a.value < b.value ? 1 : -1);
          setTimeout(()=>{
          var chart = am4core.create("maps_customers", am4charts.PieChart);
          chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

          chart.data = listCities;
          chart.radius = am4core.percent(70);
          chart.innerRadius = am4core.percent(40);
          chart.startAngle = 180;
          chart.endAngle = 360;  
          
         

          var series = chart.series.push(new am4charts.PieSeries());
          series.dataFields.value = "value";
          series.dataFields.category = "city";
          series.labels.template.fontSize= "10px";
         
          // series.labels.template.text = "[bold][/]{category}";
          // series.labels.template.text = series.labels.template.text + " : [bold]({customers} Clients)[/]";
          
          series.slices.template.cornerRadius = 10;
          series.slices.template.innerCornerRadius = 7;
          series.slices.template.draggable = true;
          series.slices.template.inert = true;
          series.alignLabels = false;
          series.colors.list = [
            am4core.color("#2a4858"),
            am4core.color("#294d5d"),
            am4core.color("#275163"),
            am4core.color("#255667"),
            am4core.color("#225b6c"),
            am4core.color("#0e6f7d"),
            am4core.color("#1ea78f"),
            am4core.color("#32b18e"),
            am4core.color("#3cb68d"),
            am4core.color("#6ecd85"),
            am4core.color("#8eda7f"),
            am4core.color("#a5e27a"),
            am4core.color("#99de7c"),
            am4core.color("#bcea75"),
            am4core.color("#c8ed73"),
            am4core.color("#d4f171"),
            am4core.color("#e0f470"),
            am4core.color("#fafa6e")
        ];
          series.hiddenState.properties.startAngle = 90;
          series.hiddenState.properties.endAngle = 90;

          chart.legend = new am4charts.Legend();
          chart.legend.maxHeight = 100;
          chart.legend.background.fill = am4core.color("#000");
          chart.legend.background.fillOpacity = 0.05;
          // chart.legend.position = "right";
// chart.legend.scrollable = true;
          chart.legend.labels.template.text = "{city}: [bold]({customers} Clients)[/]";
          chart.legend.fontSize = "10px";
          chart.legend.scrollable = true;
        }, 1000);
          // setTimeout(()=>{
          //   // Create map instance
          //   var chart = am4core.create("maps_customers", am4maps.MapChart);
          //   chart.geodata = am4geodata_worldMoroccoLow;
          //   chart.projection = new am4maps.projections.Miller();

          //   // Colors
          //   var color1 = chart.colors.getIndex(18);

          //   chart.homeGeoPoint = {
          //     latitude: 32,
          //     longitude: -7
          //   }
          //   chart.homeZoomLevel = 23;
          //   chart.minZoomLevel = 6;
          //   chart.maxZoomLevel = 100;

          //   // Create map polygon series
          //   var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
          //   polygonSeries.exclude = ["antarctica"];
          //   polygonSeries.useGeodata = true;

          //   // Configure series
          //   var polygonTemplate = polygonSeries.mapPolygons.template;
          //   polygonTemplate.fill = am4core.color("#d1fee5");

          //   // Add shadow
          //   var shadow = polygonSeries.filters.push(new am4core.DropShadowFilter());
          //   shadow.color = am4core.color("#fff");
          //   shadow.blur = 0;

          //   // Pins
          //   var imageSeries = chart.series.push(new am4maps.MapImageSeries());
          //   var imageTemplate = imageSeries.mapImages.template;
          //   imageTemplate.propertyFields.longitude = "longitude";
          //   imageTemplate.propertyFields.latitude = "latitude";
          //   imageTemplate.nonScaling = true;

          //   // Creating a pin bullet
          //   var pin = imageTemplate.createChild(am4plugins_bullets.PinBullet);
          //   chart.seriesContainer.zIndex = 10;
          //   chart.fontSize = 15;
          //   // Configuring pin appearance
          //   pin.background.fill = color1;
          //   pin.background.strokeWidth = 1;
          //   pin.background.stroke = am4core.color("#02895d");
          //   pin.background.pointerBaseWidth = 1;
          //   pin.background.pointerLength = 250;
          //   pin.background.propertyFields.pointerLength = "length";
          //   pin.circle.fill = pin.background.fill;
          //   pin.properties.scale = 1;
          //   pin.label = new am4core.Label();
          //   pin.label.text = "{percentage}%";
          //   pin.label.wrap = true;
          //   pin.label.tooltipText = "{city}"+ " ("+ "{countCustomers}"+" Clients)";
          //   pin.label.fill = am4core.color("title");

          //   // Pin data
          //   imageSeries.data = res.cities;

          //   // LABEL SHOWED SIDE OF PINS
          //   // var label = pin.createChild(am4core.Label);
          //   // label.text = "{city}";
          //   // label.fontWeight = "bold";
          //   // label.propertyFields.dy = "length";
          //   // label.propertyFields.dx = "length";
          //   // label.verticalCenter = "top";
          //   // label.fill = am4core.color("#00000");
          //   // label.adapter.add("dy", function(dy:any) {
          //   //   return (-3 + dy) * -1;
          //   // });
          //   // label.adapter.add("dx", function(dx:any) {
          //   //   return (5 + dx) * -1;
          //   // });

          //   // Creating a "heat rule" to modify "radius" of the bullet based
          //   // on value in data
          //   imageSeries.heatRules.push({
          //     "target": pin.background,
          //     "property": "radius",
          //     "min": 20,
          //     "max": 30,
          //     "dataField": "value"
          //   });          
          // }, 1000);
        }
      }
    );

  }
}
 